export default __webpack_public_path__ + "static/media/miscellaneous14.2fe08024.png";